import * as TypeGraphQL from "type-graphql";
export var AllocationScalarFieldEnum;
(function (AllocationScalarFieldEnum) {
    AllocationScalarFieldEnum["id"] = "id";
    AllocationScalarFieldEnum["equities"] = "equities";
    AllocationScalarFieldEnum["optionsContracts"] = "optionsContracts";
    AllocationScalarFieldEnum["futures"] = "futures";
    AllocationScalarFieldEnum["etfs"] = "etfs";
    AllocationScalarFieldEnum["forex"] = "forex";
    AllocationScalarFieldEnum["crypto"] = "crypto";
    AllocationScalarFieldEnum["stocks"] = "stocks";
    AllocationScalarFieldEnum["options"] = "options";
    AllocationScalarFieldEnum["alpacaAccountId"] = "alpacaAccountId";
    AllocationScalarFieldEnum["createdAt"] = "createdAt";
    AllocationScalarFieldEnum["updatedAt"] = "updatedAt";
})(AllocationScalarFieldEnum || (AllocationScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(AllocationScalarFieldEnum, {
    name: "AllocationScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=AllocationScalarFieldEnum.js.map